import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconName } from '@panaya/ui/p-icon';
import { UserRendererParams } from './user-renderer.model';

@Component({
    selector: 'entity-user-renderer',
    template: `
        <div class="entity-user-container">
            <p-icon *ngIf="avatarIcon" [name]="avatarIcon" [matTooltip]="tooltip" size="sm"></p-icon>
            <span class="entity-user common-grid-cell-value">{{ userFullName }}</span>
        </div>
    `,
    styleUrls: ['./user-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserRendererComponent {
    @Input() userFullName!: string;
    @Input() userStatus!: UserStatus;

    constructor(private translate: TranslateService) {}

    agInit(params: UserRendererParams): void {
        this.userFullName = params.getValue(params.data);
        this.userStatus = params.getUserStatus(params);
    }

    public get tooltip(): string {
        return this.userStatus === UserStatus.INACTIVE
            ? this.translate.instant('UserManagement.UserAvatar.InactiveUser')
            : this.userStatus === UserStatus.DISCONNECTED
            ? this.translate.instant('UserManagement.UserAvatar.DisconnectedUser')
            : '';
    }

    public get avatarIcon(): IconName | null {
        return this.userStatus === UserStatus.INACTIVE
            ? 'minus-circle'
            : this.userStatus === UserStatus.DISCONNECTED
            ? 'slash'
            : this.userStatus === UserStatus.GROUP
            ? 'user-groups'
            : null;
    }
}
export enum UserStatus {
    INACTIVE = 0,
    ACTIVE,
    DISCONNECTED,
    GROUP
}
